import * as tslib_1 from "tslib";
import isEqual from 'lodash-es/isEqual';
import { distinctUntilChanged, skip, } from 'rxjs/operators';
var BaseStateManager = /** @class */ (function () {
    function BaseStateManager() {
    }
    Object.defineProperty(BaseStateManager.prototype, "value", {
        get: function () {
            return this._state.getValue();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseStateManager.prototype, "value$", {
        get: function () {
            return this._value$ ?
                this._value$ :
                this._value$ = this._state.pipe(distinctUntilChanged(isEqual));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseStateManager.prototype, "change$", {
        get: function () {
            return this._change$ ?
                this._change$ :
                this._change$ = this.value$.pipe(skip(1));
        },
        enumerable: true,
        configurable: true
    });
    BaseStateManager.prototype._logStateChanges = function (managerName, logger) {
        this._state.subscribe(function (value) { return logger.log(managerName.toUpperCase() + " state change:", value); });
    };
    return BaseStateManager;
}());
var StateManager = /** @class */ (function (_super) {
    tslib_1.__extends(StateManager, _super);
    function StateManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return StateManager;
}(BaseStateManager));
export { StateManager };
var NullableStateManager = /** @class */ (function (_super) {
    tslib_1.__extends(NullableStateManager, _super);
    function NullableStateManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NullableStateManager;
}(BaseStateManager));
export { NullableStateManager };
/**
 * A state manager whose state can be null, but it never exposes that fact. Its state should become non-null inside the app initializer.
 */
var NonPublicallyNullableStateManager = /** @class */ (function (_super) {
    tslib_1.__extends(NonPublicallyNullableStateManager, _super);
    function NonPublicallyNullableStateManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NonPublicallyNullableStateManager;
}(BaseStateManager));
export { NonPublicallyNullableStateManager };
